import React, { forwardRef, useState } from "react";
import { classNames } from "../utils";
import {
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnStrikeThrough,
  EditorProvider,
  Editor,
} from "react-simple-wysiwyg";

interface IInputFieldProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  handleChange?: (text: string) => void;
  handleBlur?: ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => void;
  type?: string;
  name: string;
  label?: string;
  classes?: string;
  labelClassName?: string;
  editorClassName?: string;
  toolbar_buttons?: string[];
}

const RichTextEditor = forwardRef<HTMLTextAreaElement, IInputFieldProps>(
  (
    {
      handleChange,
      type,
      name,
      label,
      classes,
      handleBlur,
      labelClassName,
      editorClassName,
      toolbar_buttons,
      ...rest
    },
    ref
  ) => {
    const [html, setHtml] = useState<string>(
      rest.value?.toLocaleString() ?? ""
    );

    function onChange(e: any) {
      const text = e.target.value;
      setHtml(text);
      handleChange?.(text);
    }

    return (
      <div className={classes ?? "w-96"}>
        {label && (
          <label
            htmlFor={name}
            className={classNames(
              "block text-sm font-medium text-gray-600 mb-2",
              labelClassName ?? ""
            )}
          >
            {label}
          </label>
        )}
        <EditorProvider>
          <Editor
            value={html}
            onChange={onChange}
            disabled={rest.disabled}
            id={name}
            name={name}
            className={classNames(
              editorClassName ?? "",
              "bg-white",
              // Add scrollable behavior only when height is constrained
              editorClassName?.includes("h-") ? "overflow-y-auto" : ""
            )}
          >
            {toolbar_buttons && toolbar_buttons.length > 0 && (
              <Toolbar>
                {toolbar_buttons.includes("bold") && <BtnBold />}
                {toolbar_buttons.includes("italic") && <BtnItalic />}
                {toolbar_buttons.includes("underline") && <BtnUnderline />}
                {toolbar_buttons.includes("strikethrough") && (
                  <BtnStrikeThrough />
                )}
              </Toolbar>
            )}
          </Editor>
        </EditorProvider>
      </div>
    );
  }
);
export default RichTextEditor;
